import { render, staticRenderFns } from "./sales-driver-review.vue?vue&type=template&id=20e1b1d2&scoped=true"
import script from "./sales-driver-review.vue?vue&type=script&lang=js"
export * from "./sales-driver-review.vue?vue&type=script&lang=js"
import style0 from "./sales-driver-review.vue?vue&type=style&index=0&id=20e1b1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1b1d2",
  null
  
)

export default component.exports